import {
    IFormTableListPropData,
    IFormTableListRow,
    IFormTableListSection,
    TFormTableListValue
} from "@pages/payroll/payslip/formTableList/FormTableList";

export function isEditableRow(row: IFormTableListRow): boolean {
    return !!row.editableInfo;
}

/**
 * Adds fake columns to the given array of columns until it reaches the specified maximum length.
 *
 * @param columns - The current array of columns.
 * @param maxColumns - The maximum number of columns the array should have
 * @returns The updated array of columns with fake columns added.
 */
export function addFakeColumns<T extends { id: string }>(columns: T[], maxColumns: number): T[] {
    if (maxColumns <= columns?.length) {
        return columns;
    }

    let id = 0;
    const _fakeColumn = (): T => ({
        id: `fakeColumn${++id}`
    } as T);

    while (columns.length < maxColumns) {
        columns = [_fakeColumn(), ...columns];
    }

    return columns;
}

export function getEditableSections(sections: IFormTableListSection[]): IFormTableListSection[] {
    return sections.reduce((ret: IFormTableListSection[], section) => {
        const rows = section.rows.filter((row) => isEditableRow(row));
        if (rows.length) {
            ret.push({ ...section, rows });
        }
        return ret;
    }, []);
}

export function printItemValue(item: Pick<IFormTableListPropData, "value" | "formatter">, value?: TFormTableListValue): string | React.ReactElement {
    const val = value ?? item?.value;
    return (item?.formatter ? item.formatter(val as number) : val?.toString());
}
